<template>
  <b-form-group
    label="Firma Ünvanı"
    label-for="company"
  >
    <validation-provider
      #default="{ errors }"
      name="Firma Ünvanı"
      rules="required"
    >
      <b-form-input
        id="company"
        v-model="form.company"
        placeholder="Firma Ünvanı"
        :state="errors.length > 0 ? false:null"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'CustomerCompany',
  components: { BFormInput, ValidationProvider, BFormGroup },
}
</script>
